export const MIN_TRANSFORM_SCALE = 0.01;
